import { useEffect } from 'react';

import { Map as ImmutableMap } from 'immutable';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import { goalsSelectors } from 'app-components/flux/goals';
import { useAppDispatch, useAppSelector } from 'hooks/redux';

import { CONTRIBUTE_TO_GOAL_DIALOG_TYPE } from 'components/Dialogs/Goals/actions';

export const DIALOG_TYPE_LLM_GOAL_CONTRIBUTE = 'LLM_GOAL_CONTRIBUTE';

type ContributeToGoalData = {
  goalId: string;
  amount?: number;
};

type LlmGoalContributionDialogProps = {
  dialogId: string;
  data: ContributeToGoalData;
  callback: (result: { success: boolean; error?: string }) => void;
};

const LlmGoalContributionDialog = ({ dialogId, data, callback }: LlmGoalContributionDialogProps) => {
  const dispatch = useAppDispatch();
  const goal = useAppSelector((state) => goalsSelectors.getGoalById(state, data.goalId));

  useEffect(() => {
    if (!goal) {
      callback({ success: false, error: `Goal not found with ID: ${data.goalId}` });
      dispatch(rootUiActions.removeDialog(dialogId));
      return;
    }

    const contributeDialogId = `llm-contribute-goal-${data.goalId}`;

    dispatch(
      rootUiActions.createDialog(
        rootUiTypes.mkRootUiData({
          type: CONTRIBUTE_TO_GOAL_DIALOG_TYPE,
          id: contributeDialogId,
          visible: true,
          allowNesting: false,
          props: ImmutableMap({
            goal,
            context: 'llm-goal-contribute',
            amount: data.amount,
            onResult: callback,
          }),
        }),
      ),
    );

    dispatch(rootUiActions.removeDialog(dialogId));
  }, [callback, data.amount, data.goalId, dialogId, dispatch, goal]);

  return null;
};

export default LlmGoalContributionDialog;
